import React, { startTransition, useEffect, useLayoutEffect, useState } from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App, { preloadRoute } from "@/App";
import { seedFromPreload } from "@/lib/api";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

// De App wordt in een transition gerenderd (time-sliced: geen lange taken) terwijl de prerender uit index.html
// zichtbaar blijft; pas na de eerste commit verdwijnt die prerender (#root) in dezelfde frame.
function Root() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    startTransition(() => setShow(true));
  }, []);
  useLayoutEffect(() => {
    if (show) document.getElementById("root")?.remove();
  }, [show]);
  return show ? <App /> : null;
}

function start() {
  if (performance.mark) performance.mark("ecell:react-start");
  seedFromPreload(queryClient);
  window.__ecellReactMounted = true;
  const container = document.createElement("div");
  container.id = "app";
  document.body.appendChild(container);
  ReactDOM.createRoot(container).render(
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <Root />
      </QueryClientProvider>
    </React.StrictMode>,
  );
}

// Route-chunk eerst laden (parallel met React zelf), dan starten; de boot in index.html voert deze bundel pas uit
// nadat de prerender als LCP is geregistreerd (productie-build).
preloadRoute(window.location.pathname).then(start, start);
